import Axios from 'axios';

import * as localStorageHelper from '@/localStorageHelper';
import router from '@/router';

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

export const apiAxios = Axios.create({
  baseURL: API_BASE_URL,
  headers: { 'x-access-token': `${localStorageHelper.jwt.load()}` },
  responseType: 'json',
});

apiAxios.interceptors.request.use((response) => {
  const jwt = localStorageHelper.jwt.load();
  if (jwt !== null && jwt !== '') {
    response.headers = { 'x-access-token': `${localStorageHelper.jwt.load()}` };
  }

  return response;
});

apiAxios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error && error.response && error.response.status === 403) {
    // Handle 403 (Forbidden)
    router.push('/login');
    return;
  }

  // // handle error
  // Vue.toasted.error(error.response.data.error.message, {
  //   duration: 3000,
  //   position: 'top-right',
  //   type: 'error',
  // });

  if (error.response.data) {
    return (error.response);
  }

  Promise.reject(error);
  return;
});
